import { useEffect } from 'react';

/*
Escape fecha o que estiver aberto no cabeçalho — mega menu, menu mobile e
painel de acessibilidade de uma vez só. É um listener único e sempre ativo,
não um por painel: o comportamento esperado é "Escape fecha tudo".
*/
export const useEscapeKey = (onEscape: () => void) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onEscape();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onEscape]);
};

export default useEscapeKey;
